module.exports = __webpack_public_path__ + "img/_008.7d45b163.png";